module.exports = __webpack_public_path__ + "img/zzkf2.960104a4.png";